export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            联系我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            投稿与合作咨询
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            如果你有原创漫画作品希望被更多读者看到，或有商务合作需求，欢迎通过以下方式联系我们，我们会在 48 小时内回复。
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="bg-background-50 rounded-xl border border-background-200/70 p-5 text-center cursor-pointer hover:border-primary-200 transition-colors">
            <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
              <i className="ri-mail-line text-xl text-primary-600"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-1">投稿邮箱</h3>
            <p className="text-xs text-foreground-500">submission@yinghuacomics.com</p>
          </div>
          <div className="bg-background-50 rounded-xl border border-background-200/70 p-5 text-center cursor-pointer hover:border-accent-200 transition-colors">
            <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-3">
              <i className="ri-briefcase-line text-xl text-accent-600"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-1">商务合作</h3>
            <p className="text-xs text-foreground-500">business@yinghuacomics.com</p>
          </div>
          <div className="bg-background-50 rounded-xl border border-background-200/70 p-5 text-center cursor-pointer hover:border-secondary-200 transition-colors">
            <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center mx-auto mb-3">
              <i className="ri-question-answer-line text-xl text-secondary-600"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-1">意见反馈</h3>
            <p className="text-xs text-foreground-500">feedback@yinghuacomics.com</p>
          </div>
        </div>
      </div>
    </section>
  );
}